import db from './dexieConfig'
import { getHook } from '../utils/adFunctions'

const BLOCKED_PHRASES = ['you...', 'thanks for watching.']

function isFilteredOut (hookText) {
  const lower = hookText.toLowerCase()
  if (BLOCKED_PHRASES.some(phrase => lower === phrase)) return true
  return false
}

export async function checkAndCacheHooks (newAds) {
  const seenHooks = new Map()
  const deduplicatedAds = []

  for (const ad of newAds) {
    const hookText = getHook(ad)?.trim()
    if (!hookText || isFilteredOut(hookText)) {
      continue
    } else if (!seenHooks.has(hookText)) {
      seenHooks.set(hookText, true)
      deduplicatedAds.push(ad)
    }
  }

  const checkPromises = deduplicatedAds.map(async (ad) => {
    const hookText = getHook(ad)?.trim()
    if (!hookText) {
      return { ad, exists: false }
    }
    const existing = await db.uniqueHooks.where('hookText').equals(hookText).first()
    return { ad, exists: !!existing }
  })

  const checkResults = await Promise.all(checkPromises)
  const adsToAdd = checkResults.filter(result => !result.exists).map(result => result.ad)

  const adsToAddMapped = adsToAdd
    .filter(ad => getHook(ad)?.trim())
    .map((ad) => ({
      hookText: getHook(ad).trim()
    }))

  await db.uniqueHooks.bulkPut(adsToAddMapped)

  return adsToAdd
}

export async function clearUniqueHooks () {
  await db.uniqueHooks.clear()
}
